
import { mapState } from 'vuex';
import DirectoryResource from '@structure/Resources/Directory';
import Directory from '@components/tree/Directory.vue';

export default {
  computed: {
    ...mapState(['sidebar']),

    rootDirectory() {
      return new DirectoryResource(this.$store.state.structure);
    },

    classes() {
      const classes = [];

      if (!this.sidebar) {
        classes.push('closed');
      }

      return classes;
    },
  },

  components: {
    Directory,
  },
};
